/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const patchApiTracksIdUploadStatusPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор трека")
    })

/**
 * @description Загрузка подтверждена
 */
export const patchApiTracksIdUploadStatus200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const patchApiTracksIdUploadStatus400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const patchApiTracksIdUploadStatus401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const patchApiTracksIdUploadStatus403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Трек не найден
 */
export const patchApiTracksIdUploadStatus404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const patchApiTracksIdUploadStatus500Schema = z.lazy(() => badResponseModelSchema)

export const patchApiTracksIdUploadStatusMutationResponseSchema = z.lazy(() => patchApiTracksIdUploadStatus200Schema)